import { create } from 'zustand'
import { Icon } from './Icon'
import { sfx } from '../lib/sound'
import { useEffect } from 'react'

interface Toast { id: number; text: string; kind: 'info' | 'ok'; out?: boolean }
const useToasts = create<{ list: Toast[]; warn: string | null; warnKey: number }>(() => ({ list: [], warn: null, warnKey: 0 }))
let seq = 0

export function toast(text: string, kind: 'info' | 'ok' = 'info', ms = 2400) {
  const id = ++seq
  useToasts.setState((s) => ({ list: [...s.list.filter((t) => t.text !== text), { id, text, kind }].slice(-3) }))
  setTimeout(() => useToasts.setState((s) => ({ list: s.list.map((t) => (t.id === id ? { ...t, out: true } : t)) })), ms)
  setTimeout(() => useToasts.setState((s) => ({ list: s.list.filter((t) => t.id !== id) })), ms + 220)
}

/* A refusal belongs where you are looking: one red bar drops from the top and goes away again. */
let warnT: ReturnType<typeof setTimeout> | undefined
export function warnTop(text: string) {
  useToasts.setState((s) => ({ warn: text, warnKey: s.warnKey + 1 }))
  sfx('low')
  clearTimeout(warnT)
  warnT = setTimeout(() => useToasts.setState({ warn: null }), 4000)
}

export function Toaster() {
  const { list, warn, warnKey } = useToasts()
  useEffect(() => () => clearTimeout(warnT), [])
  return (
    <>
      <div className="toasts" aria-live="polite">
        {list.map((t) => (
          <div key={t.id} className={`toast ${t.kind}${t.out ? ' out' : ''}`}>
            {t.kind === 'ok' && <Icon id="i-check" />}
            {t.text}
          </div>
        ))}
      </div>
      <div key={warnKey} className={`warnbar${warn ? ' on' : ''}`} role="alert" onClick={() => useToasts.setState({ warn: null })}>
        {warn}
      </div>
    </>
  )
}
